import styled from 'styled-components';
import { PageHeader } from 'ui/pageHeader';
import { colors, spacing, heading3, captionMedium } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p584: pxToRem(584),
};

export const StyledPageHeader = styled(PageHeader)`
  padding: ${spacing.double};
  background-color: ${colors.backgroundSecondary};
  margin: -${spacing.layoutTopPadding} 0 0;

  [data-page-header-content='true'] > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${spacing.quarter};

    [data-type='link'] {
      margin-bottom: 0;
    }
  }
`;

export const DestinationTitle = styled.div`
  ${heading3}
  
  display: flex;
  width: ${spacing.x32};
  height: ${spacing.doubleHalf};
  max-width: ${customSpacing.p584};
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DestinationInfo = styled.div`
  ${captionMedium}
  color: ${colors.textSecondary};
  display: flex;
  align-items: center;
  gap: ${spacing.half};
  min-width: ${spacing.x40};
`;

export const MenuButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  color: ${colors.textSecondary};
  padding: ${spacing.half};
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    color: ${colors.textPrimary};
    background-color: ${colors.backgroundTertiary};
  }
`;
